export default {
    title_challenge: 'Desafíos',
    read_following_text_award: 'Al leer el siguiente texto obtendrás',
    by_correct_answer: 'por respuesta correcta',
    beeCoins_perfect_result: 'BeeCoins por resultado perfecto',
    finishReading: 'Terminar lectura',
    done: 'LISTO',
    nowToTheQuestions: 'Ahora tranquilamente vamos con las preguntas',
    goToQuestions: 'Ir a las preguntas',
    sendAnswers: 'Enviar respuestas',
    mustAnswerTheQuestions: 'Debes responder todas las preguntas',
    tooFast: 'MUY RÁPIDO',
    fast: 'RÁPIDO',
    medium: 'MEDIO',
    youCanImprove: '¡Vamos! Puedes mejorar',
    closeKeepTrying: '¡Uuuuyy, casi! Sigue intentándolo',
    wellDone: '¡Así se hace! ¡Genial!',
    findYourMistakes: 'Encuentra tus errores',
    lastChance: 'Última oportunidad',
    getReward: 'Obtener recompensa',
    readingSpeed: 'Velocidad Lectora',
    youRead: 'Leíste',
    words: 'palabras',
    byMinute: 'por minuto',
    yourReadingLevel: 'Tu nivel de lectura es',
    comprehension: 'Comprensión',
    correctAnswers: 'Respuestas Correctas',
    incorrectAnswers: 'Respuestas Incorrectas',
    fantastic: '¡Fantástico!',
    youHaveWon: 'Has logrado ganar',
    doAnotherChallenge: 'Hacer otro desafío',
    goHome: 'Ir a inicio',
    initial_challenge_title: 'Desafío',
    initial_text_you_will_get:
        'Cuando leemos construimos un nuevo conocimiento a partir de la información del texto y los saberes que ya tenemos.',
    initial_text_points: 'puntos',
    initial_text_button: 'Comenzar este desafío',
    initial_card_title_1: 'Antes de comenzar este desafío, debes saber que:',
    initial_card_title_2: 'Existen 3 niveles de comprensión lectora:',
    initial_card_title_3: '',
    initial_card_text_1:
        'Tienes la misión de leer un texto breve y contestar 4 preguntas. Responde todo correctamente y alcanza alguna de las recompensas que te mostramos a continuación.',
    initial_card_text_2: [
        'Nivel literal: ir a la información está en el texto.',
        'Nivel inferencial: ir a la información está en el texto y en nosotros.',
        'Nivel valorativo: ir más allá de la información que nos presenta el texto, integrando conocimientos, valoraciones y juicios.',
    ],
    initial_card_text_3:
        'El texto que encontrarás a continuación tiene preguntas que te pondrán a prueba, así que lee con atención.',
    text_next: 'Siguiente',
    text_back: 'Regresar',
    resolve_challenge: 'Enviar desafío',
    new_challenge: 'Nuevo desafío',
    very_well_done: '¡Muy bien hecho!',
    please_try_again: '¡Inténtalo nuevamente!',
    try_again_msg_2: 'Aún estás a tiempo de mejorar tus habilidades lectoras. ¡No te rindas!',
    excellent_work_mission_accomplished: 'Excelente trabajo, misión cumplida',
    success_msg: 'Como has respondido correctamente, ganas lo siguiente:',
    result_msg_0: 'No tengas miedo de cometer errores. Sigue practicando y verás cómo mejoras con cada intento.',
    result_msg_1: 'Aún estás a tiempo de mejorar tus habilidades lectoras. ¡No te rindas!',
    result_msg_2: 'Aún estás a tiempo de mejorar tus habilidades lectoras. ¡No te rindas!',
    result_msg_3: 'Continúa practicando tus habilidades de lectura y descubriendo nuevos textos.',
    result_msg_4: 'Respondiste correctamente todas las preguntas. Sigue así, ¡estás en camino hacia el éxito en la lectura!',
    title_msg_0: '¡Prueba otra vez!',
    title_msg_1: '¡Sigue esforzándote!',
    title_msg_2: '¡No te desanimes!',
    title_msg_3: '¡Casi perfecto!',
    title_msg_4: '¡Excelente trabajo!',
    your_rewards: 'Tus recompensas',
    collect_prize: 'Recoger premio',
    result: 'Resultado',
    font: 'Tipo de letra',
    text_size: 'Tamaño del texto',
    do_not_be_discouraged: 'No te desanimes',
    fail_msg: 'En está oportunidad has logrado ganar lo siguiente:',
    prize_breakdown: '¿Cuántos puntos y BeeCoins puedo ganar?',
    you_win: 'Respuestas correctas ganarás',
    win4: '20 puntos y 20 BeeCoins',
    win3: '15 puntos y 4 BeeCoins',
    win2: '10 puntos y 3 BeeCoins',
    win1: '5 puntos y 2 BeeCoins',
    try_again_msg: 'Concéntrate un poco más e inténtalo nuevamente.',
    go_to_questions: 'Ir a las preguntas',
    rewards: 'Recompensas',
    correct_answers: 'Respuestas correctas',
    beginning_initial_challenge_title: 'Desafíos',
    beginning_initial_challenge_set_question_option: 'Elije si quieres contestar con:',
    beginning_initial_challenge_premessage_text: 'Tu objetivo es leer y contestar las preguntas sobre los textos.',
    beginning_initial_challenge_question_option_words: 'Palabras',
    beginning_initial_challenge_question_option_images: 'Imágenes',
    take_a_challenge_and_earn_rewards: '¡Haz un desafío y gana recompensas!',
    test_your_reading_skills: 'Pon a prueba tus habilidades de lectura',
    start_challenge: 'Comenzar desafío',
    details: 'Detalles',
    duplicate_submission_error: 'Este desafío ya ha sido completado. No se permite enviar respuestas duplicadas.',
}
